import classnames from 'classnames';
import React from 'react';

const CSS = require('./RadioButton.module.scss');

interface RadioButtonProps {
  className?: string;
  outerCircleClassName?: string;
  innerCircleClassName?: string;
  checked?: boolean;
  value?: string;
  name?: string;
  onClick?: (e: any) => void;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  onFocus?: (e: any) => void;
  required?: boolean;
  disabled?: boolean;
  error?: any;
  size?: 'M' | 'S';
  variant?: 'default' | 'black';
  [key: string]: any;
}

function RadioButton({
  className,
  checked,
  value,
  name,
  onClick,
  onChange,
  onBlur,
  onFocus,
  required,
  disabled,
  error,
  outerCircleClassName,
  innerCircleClassName,
  size = 'M',
  variant = 'default',
  ...rest
}: RadioButtonProps) {
  return (
    <div
      className={classnames(CSS.Container, {
        [className]: className,
        [CSS.ContainerSmall]: size === 'S',
      })}
      data-test-id="RadioButton"
    >
      <input
        className={CSS.RadioButton}
        type="radio"
        checked={checked}
        value={value}
        name={name}
        onClick={onClick}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        required={required}
        readOnly
        disabled={disabled}
        {...rest}
      />
      <span
        className={classnames(CSS.OuterCircle, {
          [CSS.OuterCircleChecked]: checked,
          [CSS.Error]: error,
          [outerCircleClassName]: !!outerCircleClassName,
          [CSS.OuterCircleSmall]: size === 'S',
        })}
        data-variant={variant}
      >
        <span
          className={classnames(CSS.InnerCircle, {
            [CSS.InnerCircleChecked]: checked,
            [innerCircleClassName]: !!innerCircleClassName,
            [CSS.InnerCircleSmall]: size === 'S',
          })}
          data-variant={variant}
        />
      </span>
    </div>
  );
}

export default RadioButton;
